export default __webpack_public_path__ + "static/media/no-results.e932e51c.png";